import { render, staticRenderFns } from "./ProjectDataForm.vue?vue&type=template&id=48b31843&scoped=true"
import script from "./ProjectDataForm.vue?vue&type=script&lang=js"
export * from "./ProjectDataForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectDataForm.vue?vue&type=style&index=0&id=48b31843&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b31843",
  null
  
)

export default component.exports